<template>
  <div class="routerView">
    <LoginPage></LoginPage>
  </div>
</template>

<script>
import LoginPage from './components/LoginPage.vue';

export default {
  name: 'App',
  components: {
    LoginPage
  },
  created() { },
  methods : { }
}
</script>

<style>

:root {

--nomeco-blue     :  #00205c;
--nomeco-green    :  #088573;
--nomeco-lightgreen : #daedea;
--nomeco-red      : #b14b50;
--nomeco-lightred : #fbc8c8;

}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color:var(--nomeco-blue);
  
}

.routerView {   
                margin : 0 auto auto auto;
                padding: 0px;
                max-width: 1326px; 
              
              }

                .footer {
    height : 102px;
    width: 100%}


    h1 {
 
  font-size: 30px;
}


h2 {
 
  font-size: 18px;
}


h3 {
 
  font-size: 12px;
}

.small {
   font-size: 8px;
}

.body {
  font-size: 12px;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: var(--nomeco-green);
}

nav a.router-link-exact-active {
  color: #42b983;
}

.text-align-left {
    text-align: left;
}


.left-padding {
    padding-left:10px
}

.text-align-center {
  text-align: center 
  }
</style>
